import { Arr, ListStore, memone } from '@deqo/foundation';
import { Pawn } from './Pawn';

export class PawnManager extends ListStore<Pawn> {

    private get index() {
        return this.buildIndexById(this.getState());
    }

    public create(id: string) {
        if (this.index.has(id)) return;
        const pawn = new Pawn(id);
        this.updateState(x => x.push(pawn));
        return pawn;
    }

    public delete(id: string) {
        const pawn = this.get(id);
        this.updateState(x => Arr.remove(x, pawn));
    }

    public get(id: string) {
        return this.index.get(id) ?? null;
    }

    @memone()
    private buildIndexById(state: Pawn[]) {
        return new Map(state.map(x => [x.id, x]));
    }
}
